import {IconCopy} from "@tabler/icons-react";
import {DatePicker, Form, Input, message, Select} from "@ui";
import PropTypes from "prop-types";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import {PrimaryButton, SecondaryButton} from "@/components/Button";
import {adapterBankList} from "../../../../adapters/bankListAdapter";
import useDepositPagoMovil from "../../../../hooks/wallet/usePostDepositPagoMovil";
import {useAppConfig} from "../../../../store/useAppConfig.store";
import styles from "../bankOptions.module.css";

const BankVzla = ({onBack}) => {
  const RIF = useAppConfig(state => state.RIF);
  const PagoMovilNumber = useAppConfig(state => state.PagoMovilNumber);

  const {t} = useTranslation();

  const [form] = Form.useForm();
  const [canSubmit, setCanSubmit] = useState(false);

  const {mutate, isPending} = useDepositPagoMovil();

  const handleFormChange = (_changedValues, allValues) => {
    const isComplete = !!(allValues.referencia && allValues.importe && allValues.fecha && allValues.banco_origen);
    setCanSubmit(isComplete);
  };

  const handleDeposit = values => {
    const fechaFormated = values.fecha.format("YYYY-MM-DD");
    values.fecha = fechaFormated;

    const bancoFormated = `0${values.banco_origen}`;
    values.banco_origen = bancoFormated;

    const importeFormated = Number.parseFloat(values.importe);
    values.importe = importeFormated;

    mutate(values);
  };

  const copyToClipboard = async text => {
    try {
      await navigator.clipboard.writeText(text);
      message.success(t("depositInstructionsCopied"));
    } catch {
      message.error(t("depositInstructionsError"));
    }
  };

  return (
    <div className={styles.depositLayout}>
      {/* 1. Header */}
      <h3 className={styles.depositTitle}>{t("depositInstructions")}</h3>

      {/* 2. Instructions */}
      <p className={styles.depositInstructions}>{t("depositInstructionsMessageVzla")}</p>

      {/* 3. Payment information card */}
      <div className={styles.paymentInfoCard}>
        <button
          type="button"
          className={styles.paymentInfoRow}
          onClick={() => copyToClipboard(RIF)}
        >
          <div className={styles.paymentInfoLabel}>
            <span className={styles.paymentInfoKey}>RIF</span>
            <span className={styles.paymentInfoValue}>{RIF}</span>
          </div>
          <IconCopy
            size={16}
            className={styles.copyIcon}
          />
        </button>
        <button
          type="button"
          className={styles.paymentInfoRow}
          onClick={() => copyToClipboard(PagoMovilNumber)}
        >
          <div className={styles.paymentInfoLabel}>
            <span className={styles.paymentInfoKey}>{t("depositInstructionsMobilePhone")}</span>
            <span className={styles.paymentInfoValue}>{PagoMovilNumber}</span>
          </div>
          <IconCopy
            size={16}
            className={styles.copyIcon}
          />
        </button>
      </div>

      {/* 4. Deposit form */}
      <Form
        form={form}
        layout="vertical"
        onFinish={handleDeposit}
        onValuesChange={handleFormChange}
      >
        <div className={styles.formGrid3}>
          <Form.Item
            name="referencia"
            label={t("depositInstructionsBankVzlaReference")}
            rules={[{required: true}]}
          >
            <Input placeholder="000191969387" />
          </Form.Item>
          <Form.Item
            name="importe"
            label={t("depositInstructionsBankVzlaAmount")}
            rules={[{required: true}]}
          >
            <Input placeholder="0.00" />
          </Form.Item>
          <Form.Item
            name="fecha"
            label={t("depositInstructionsBankVzlaDate")}
            rules={[{required: true}]}
          >
            <DatePicker
              format="YYYY-MM-DD"
              placeholder={t("depositInstructionsBankVzlaSelectDate")}
              className={styles.fullWidth}
            />
          </Form.Item>
        </div>

        <Form.Item
          name="banco_origen"
          label={t("mobilePaymentModalBank")}
          rules={[{required: true, message: t("mobilePaymentModalSelectBankMessage")}]}
        >
          <Select
            showSearch
            placeholder={t("mobilePaymentModalSelectBank")}
            optionFilterProp="children"
            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
          >
            {adapterBankList().map(item => (
              <Select.Option
                key={item.value}
                value={item.value}
              >
                {item.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        {/* 5. Footer actions */}
        <div className={styles.depositFooter}>
          <SecondaryButton onClick={onBack}>{t("depositInstructionsBack")}</SecondaryButton>
          <PrimaryButton
            htmlType="submit"
            loading={isPending}
            disabled={isPending || !canSubmit}
          >
            {t("depositInstructionsContinue")}
          </PrimaryButton>
        </div>
      </Form>
    </div>
  );
};

BankVzla.propTypes = {
  onBack: PropTypes.func,
};

export default BankVzla;
